<!--店铺下拉框多选-->
<script>
import api from "@/api/projectApi";

export default {
  name: 'buyShopMultipleSelect',
  props: ['buyShopIdList'],
  mounted() {
    this.loadData()
  },
  data() {
    return {
      selectOption: []
    }
  },
  methods: {
    selectChange() {
      this.$emit('update:buyShopIdList', this.buyShopIdList)
    },

    clear() {
      this.$emit('update:buyShopIdList', [])
    },

    loadData() {
      this.$http.post(api.basBuyShop.getListUrl, {}).then(res => {
        this.selectOption = res.data.data
      })
    },
  }
}
</script>

<template>
  <div>
    <el-select v-model="buyShopIdList"
               @change="selectChange"
               @clear="clear"
               :multiple="true"
               :clearable="true"
               placeholder="请选择"
               style="width: 100%;"
               filterable
    >
      <el-option v-for="item in selectOption"
                 :key="item.id"
                 :label="item.shopName"
                 :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>
